// extracted by mini-css-extract-plugin
export default {"pinnedArea":"PageView_pinnedArea__6zXyA","unpinnedArea":"PageView_unpinnedArea__+bVjd"};